import { createRouter, createWebHashHistory } from 'vue-router';
import store from '@/store/index';
import cookie from 'js-cookie';
import { queryUserInfo } from '@/api/user';
import { getToken } from '@/api';
import Landing from '../views/landing.vue';

const routes = [
  {
    path: '/',
    name: 'landing',
    component: Landing,
  },
  {
    path: '/game',
    name: 'game',
    component: () => import('@/views/game.vue'),
  },
  {
    path: '/story',
    name: 'story',
    component: () => import('@/views/story/index1.vue'),
  },
  {
    path: '/randomView',
    name: 'randomView',
    component: () => import('@/views/randomView.vue'),
  },
  {
    path: '/randomViewplayer',
    name: 'randomViewplayer',
    component: () => import('@/views/randomViewplayer.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (!cookie.get('access_token')) {
    const { access_token, access_token_timeout } = await getToken();
    // cookie.set('access_token', access_token, { expires: new Date(access_token_timeout * 1000) });
  }
  if (['/login'].includes(to.path)) {
    next();
  } else {
    const user_token = _sdk_.getUserLoginSession() || sessionStorage.getItem('user_token');
    if (user_token) {
      const { unid } = store.state.userInfo;
      if (unid) {
        next();
      } else {
        const userInfo = await queryUserInfo();
        store.commit({
          type: 'update',
          payload: {
            key: 'userInfo',
            value: userInfo.data,
          },
        });
        next();
      }
    } else {
      next('/login');
    }
  }
});

export default router;
